const RELOAD_MARK = 'sportpark:stale-chunk-reload-at';

export const STALE_CHUNK_RELOAD_WINDOW_MS = 30_000;

export const staleChunkRuntime = {
  reload: (): void => window.location.reload(),
  now: (): number => Date.now(),
};

export const staleChunkState = { reloading: false };

export const isStaleChunkError = (error: unknown): boolean => {
  const message = error instanceof Error ? error.message : typeof error === 'string' ? error : '';
  return /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS/i.test(
    message,
  );
};

const readMark = (): number | null => {
  try {
    const raw = sessionStorage.getItem(RELOAD_MARK);
    return raw === null ? null : Number(raw);
  } catch {
    return null;
  }
};

const writeMark = (at: number): boolean => {
  try {
    sessionStorage.setItem(RELOAD_MARK, String(at));
    return true;
  } catch {
    return false;
  }
};

export const reloadOnceForNewVersion = (): boolean => {
  const now = staleChunkRuntime.now();
  const mark = readMark();
  if (mark !== null && Number.isFinite(mark) && now - mark < STALE_CHUNK_RELOAD_WINDOW_MS) return false;
  if (!writeMark(now)) return false;
  staleChunkState.reloading = true;
  staleChunkRuntime.reload();
  return true;
};

export const installStaleChunkReload = (target: Window): void => {
  target.addEventListener('vite:preloadError', (event) => {
    if (reloadOnceForNewVersion()) event.preventDefault();
  });
};
